import Vue from 'vue';
import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';

Vue.use(VuejsDialog, {
  customClass: 'vvs-dialog',
  okText: 'Evet',
  cancelText: 'Hayır',
  animation: 'fade',
  html: true,
});
